const CalendarIcon = () => {
    return (
        <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 9.79004H4.5V11.79H6.5V9.79004ZM10.5 9.79004H8.5V11.79H10.5V9.79004ZM14.5 9.79004H12.5V11.79H14.5V9.79004ZM16.5 2.79004H15.5V0.790039H13.5V2.79004H5.5V0.790039H3.5V2.79004H2.5C1.39 2.79004 0.51 3.69004 0.51 4.79004L0.5 18.79C0.5 19.89 1.39 20.79 2.5 20.79H16.5C17.6 20.79 18.5 19.89 18.5 18.79V4.79004C18.5 3.69004 17.6 2.79004 16.5 2.79004ZM16.5 18.79H2.5V7.79004H16.5V18.79Z" fill="white"/>
        </svg>        
    );
  };
  
  export default CalendarIcon;
  